module.exports = __webpack_public_path__ + "img/kleisma4.332eeda0.webp";